'use strict';

import DefaultGenerator from "./DefaultGenerator.js";

export default class CSVGenerator extends DefaultGenerator {
	_mimeType = 'text/csv';
	_extension = 'csv';

		generate(data, sub = false, offset = 0) {
			let csv = '';

			if (!Array.isArray(data)){
				data = [data];
			}

			const headings = Object.keys(data[0]);

			const offsetColumns = '"",'.repeat(offset)
			offsetColumns.slice(-1);

			csv += offsetColumns;

			if (sub) {
				headings.forEach((key, index) => {
					if (index !== 0) csv += ',';

					csv += `"${key}"`;
				});
			}

			csv += "\r";

			data.forEach((row, index) => {
				csv += offsetColumns;

				let subRows = '';

				Object.values(row).forEach((value, index) => {
					if (index !== 0) csv += ',';

					if (typeof value.subitems === 'object') {
						csv += `"${value.value}"`;
						subRows += this.generate(value.subitems, true, index + offset)
					} else {
						let cleanedValue = this.extractTextFromHtml(value);
						csv += `"${cleanedValue}"`;
					}
				});

				csv += '\r'
				csv += subRows;
			});

			return sub ? csv : super.generate(data, csv)
		}

	extractTextFromHtml(html) {
		let doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || "";
	}
	download() {
		this._filename = 'Levcharity ' + this._filename_default;
		super.download();
	}
}
